import { render, staticRenderFns } from "./TeamDetailsDialog.vue?vue&type=template&id=1b86769b&scoped=true"
import script from "./TeamDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TeamDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamDetailsDialog.vue?vue&type=style&index=0&id=1b86769b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b86769b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
